"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Preferences extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'preferences';
        this._customKpiDefaults = (0, util_1.camelArray)(initParams.custom_kpi_defaults);
    }
    set customKpiDefaults(value) {
        console.error('Do not set objects this way');
    }
    setCustomKpiDefaults(value) {
        return this.dataService.updatePreferences(this.id, { custom_kpi_defaults: (0, util_1.snakeArray)(value) }, this);
    }
    get customKpiDefaults() {
        return this._customKpiDefaults;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updatePreferences(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = Preferences;
//# sourceMappingURL=preferences.js.map